export default {
    name: 'HistoryTab',
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedChangelogItem: null
        }
    },
    computed: {
        hasChangelog() {
            return this.recallData &&
             this.recallData.changelog &&
             Array.isArray(this.recallData.changelog) &&
             this.recallData.changelog.length > 0
        },

        sortedChangelog() {
            if (!this.hasChangelog) return []

            // Don't filter, show all changelog entries
            // Map with original index to maintain order when timestamps are identical
            return [...this.recallData.changelog]
                .map((entry, index) => ({ entry, index }))
                .sort((a, b) => {
                    // Handle MongoDB timestamp format with $date field
                    const aTime = a.entry.timestamp?.$date || a.entry.timestamp
                    const bTime = b.entry.timestamp?.$date || b.entry.timestamp
                    const timeDiff = new Date(bTime) - new Date(aTime)
                    // If timestamps are equal, maintain original order (reverse it since we're sorting desc)
                    if (timeDiff === 0) {
                        return b.index - a.index
                    }
                    return timeDiff
                })
                .map(item => item.entry)
        }
    },
    watch: {
        sortedChangelog: {
            handler(newChangelog, oldChangelog) {
                if (newChangelog.length > 0) {
                    // If changelog has changed (new data loaded), select the first item
                    if (!oldChangelog || oldChangelog.length !== newChangelog.length || !this.selectedChangelogItem) {
                        this.selectedChangelogItem = newChangelog[0]
                    }
                    // If the currently selected item doesn't exist in new data, select first item
                    else if (!newChangelog.find(item => item.timestamp === this.selectedChangelogItem?.timestamp)) {
                        this.selectedChangelogItem = newChangelog[0]
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        selectChangelogItem(entry) {
            this.selectedChangelogItem = entry
        },
        formatDateTime(date) {
            if (!date) return '-'
            try {
                const dateValue = date?.$date || date
                const d = new Date(dateValue)
                if (isNaN(d.getTime())) return '-'
                // Format as absolute UTC date/time
                const pad = n => n.toString().padStart(2, '0')
                let hours = d.getUTCHours()
                const minutes = pad(d.getUTCMinutes())
                const seconds = pad(d.getUTCSeconds())
                const ampm = hours >= 12 ? 'PM' : 'AM'
                hours = hours % 12
                hours = hours ? hours : 12 // the hour '0' should be '12'
                return `${pad(d.getUTCMonth() + 1)}/${pad(d.getUTCDate())}/${d.getUTCFullYear()} ${pad(hours)}:${minutes}:${seconds} ${ampm}`
            } catch (error) {
                return '-'
            }
        },

        // formatDateTime(date) {
        //     if (!date) return '-'
        //     try {
        //         // Handle MongoDB timestamp format with $date field
        //         const dateStr = date?.$date || date
        //         const d = new Date(dateStr)
        //         if (isNaN(d.getTime())) return '-'
        //         return d.toLocaleString('en-US', {
        //             year: 'numeric',
        //             month: '2-digit',
        //             day: '2-digit',
        //             hour: '2-digit',
        //             minute: '2-digit',
        //             second: '2-digit',
        //             hour12: true
        //         })
        //     } catch (error) {
        //         return '-'
        //     }
        // },

        getFieldDisplayName(fieldName) {
            const displayNames = {
                'recall_name': 'Recall Name',
                'recall_id': 'Recall ID',
                'recall_date': 'Recall Date',
                'recalling_firm': 'Recalling Firm',
                'manufacturer': 'Manufacturer',
                'response_email': 'Response Email',
                'urgent': 'Urgent',
                'description': 'Description',
                'health_risk': 'Health Risk',
                'actions': 'Actions',
                'recall_type': 'Recall Type',
                'fda_classification': 'FDA Classification',
                'isVoluntary': 'Is Voluntary',
                'instructions': 'Instructions',
                'recall_category': 'Recall Group',
                'additional_contact_info': 'Additional Contact Info',
                'product_list': 'Products',
                'correction': 'Correction',
                'status': 'Status'
            }

            return displayNames[fieldName] || fieldName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
        },

        formatValueForDisplay(value, fieldName = '') {
            if (value === null || value === undefined) return '(empty)'
            if (value === '') return '(empty string)'
            if (fieldName && fieldName.toLowerCase().includes('urgent')) {
                if (value === true || value === 'true' || value === 'TRUE') return 'YES'
                if (value === false || value === 'false' || value === 'FALSE') return 'NO'
            }
            const dateFields = [
                'recall_date',
                'distribution_start_date',
                'distribution_end_date',
                'expiration_start_date',
                'expiration_end_date',
                'manufactured_start_date',
                'manufactured_end_date',
                'ship_date'
            ]
            // Check if the field name (including nested fields like product_1.distribution_start_date) contains any date field
            const isDateField = dateFields.some(dateField =>
                fieldName.toLowerCase().includes(dateField)
            )
            if (isDateField) {
                // Handle MongoDB $date format: { "$date": "2022-10-18T00:00:00.000Z" }
                const dateValue = (typeof value === 'object' && value?.$date) ? value.$date : value
                // Parse date directly from string to avoid timezone issues
                const dateMatch = String(dateValue).match(/(\d{4})-(\d{2})-(\d{2})/)
                if (dateMatch) {
                    const year = dateMatch[1]
                    const month = dateMatch[2]
                    const day = dateMatch[3]
                    return `${month}/${day}/${year}`
                }
            }
            if (typeof value === 'object') return JSON.stringify(value, null, 2)
            return String(value)
        }
    }
}
